<div class="statistics-panel-wrapper">
    <div>
        @if (panelData().showWarning && panelData().warningTooltip) {
            <div
                class="warning-icon"
                (clickOutside)="panelData().warningTooltip.show = false"
                (click)="panelData().warningTooltip.show = !panelData().warningTooltip.show"
            >
                <ev_tooltip [visible]="panelData().warningTooltip?.show" [top]="27" [left]="1"  [arrow]="'top'" [arrowTopAlign]="-7" [arrowAlignLeft]="17">
                    <div class="popup-info">
                        <div class="header">{{ panelData().warningTooltip?.header }}</div>
                        @for (txt of panelData().warningTooltip?.info; track txt) {
                            <div class="body">{{ txt }}</div>
                        }
                    </div>
                </ev_tooltip>
            </div>
        }
        <div class="statistics-panel">
            <div class="main-info">
                <div class="header-text">{{ panelData().headerTxt }}</div>
                <div class="header-text grey">{{ panelData().subTxt }}</div>
                <div class="value">{{ panelData().average > 0 ? panelData().average : "-" }}</div>
            </div>

            <div class="range-container">
                <div class="row">
                    <div class="text grey">Median</div>
                    <div class="value">{{ panelData().median }}</div>
                </div>
                @for (range of panelData().ranges; track range) {
                    <div class="row">
                        <div class="range grey">{{ range.lowBound }}</div>
                        <div class="divider grey">{{ range.upperBound === "" ? "»" : "-" }}</div>
                        <div class="range grey">{{ range.upperBound }}</div>
                        <div class="value">{{ range.value }} %</div>
                    </div>
                }
                <div class="row">
                    <div class="text grey">{{ panelData().total < 100000 ? "Grunnlag" : "Gr.lag" }}</div>
                    <div class="value">{{ panelData().total }}</div>
                </div>
            </div>

            <div class="info-icon" (clickOutside)="panelData().tooltip.show = false" (click)="panelData().tooltip.show = !panelData().tooltip.show">
                <ev_tooltip [visible]="panelData().tooltip.show" [left]="-270" [top]="27" [arrow]="'top'" [arrowTopAlign]="-7" [arrowAlignRight]="17">
                    <div class="popup-info">
                        <div class="header">{{ panelData().tooltip.header }}</div>
                        @for (txt of panelData().tooltip.info; track txt) {
                            <div class="body">{{ txt }}</div>
                        }
                    </div>
                </ev_tooltip>
            </div>
        </div>
    </div>
</div>
